export default {
    install(Vue) {
        Vue.prototype.test = function() { //定义全局函数test
            this.GLobal.x++ //test逻辑为全局变量x+1
        };
    }
}